import { IconWrapper } from '../runtime';
export default IconWrapper('merge-cells', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M14.25 5.99976V3.24976C14.25 2.42133 13.5784 1.74976 12.75 1.74976L9.125 1.74976M14.25 10.1248V12.7498C14.25 13.5782 13.5784 14.2498 12.75 14.2498H9.125M7 1.74976L3.25 1.74976C2.42157 1.74976 1.75 2.42133 1.75 3.24976L1.75 5.87476M7 14.2498H3.25C2.42157 14.2498 1.75 13.5782 1.75 12.7498L1.75 9.99976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M4.5 6.74976L6 7.99976M6 7.99976L4.5 9.24976M6 7.99976H1.75M11.5 6.74976L10 7.99976M10 7.99976L11.5 9.24976M10 7.99976H14.25",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});